import type { AppLocale } from '../../../i18n/types';
import type { DocPage } from '../types';
import { docPages as docPagesFr } from './pages';
import { docPagesEn } from './pages.en';

/**
 * Pages documentation selon la locale.
 * FR = source complète ; EN = catalogue complet (merge avec fallback FR si clé absente).
 */
export function resolveDocPages(locale: AppLocale): Record<string, DocPage> {
  if (locale !== 'en') {
    return docPagesFr;
  }

  const merged: Record<string, DocPage> = { ...docPagesFr };
  for (const [key, page] of Object.entries(docPagesEn)) {
    if (page) {
      merged[key] = page;
    }
  }
  return merged;
}

export { defaultDocPageKey } from './pages';
